import React, { Component } from 'react';

class HLSErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can log the error or send it to an error reporting service
        console.error(error);
    }

    render() {
        if (this.state.hasError) {
            // You can customize the error message or render a fallback UI
            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}

export default HLSErrorBoundary;